export default __webpack_public_path__ + "static/media/Background_00112.1e8cbcc9.png";